import React from "react";

interface SummaryColumnProps {
  label: string;
  value: string | number;
  color?: string;
}

const SummaryColumn: React.FC<SummaryColumnProps> = ({
  label,
  value,
  color = "#ff0000",
}) => {
  return (
    <th className="h-12 text-left align-middle font-medium text-muted-foreground">
      <div className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 underline-offset-4 hover:underline h-10 py-2 px-3 cursor-pointer text-[#0F172A] font-normal">
        {label}
        <b className="font-bold" style={{ color }}>
          {value}
        </b>
      </div>
    </th>
  );
};

export default SummaryColumn;
